module.exports = __webpack_public_path__ + "img/Claim.d6de6164.svg";